
/**
 * HexカラーコードをRGBに変換する
 *
 * @param {String} colorCode Hexカラーコード
 * @return {Number[]} RGBカラーコードの配列
 */
const getConvertHexToRgb = (colorCode) => {
    let hex = colorCode;

    if (hex.length === 3) {
        hex = `${hex.slice(0, 1)}${hex.slice(0, 1)}${hex.slice(1, 2)}${hex.slice(1, 2)}${hex.slice(2, 3)}${hex.slice(2, 3)}`;
    }

    return [hex.slice(0, 2), hex.slice(2, 4), hex.slice(4, 6)].map((str) => parseInt(str, 16));
};


/**
 * 背景色をシステム側で指定したカラーコードに変更する
 * 基本は作品詳細ページでのみ使用する想定
 *
 * @param {Element} root ルート要素
 */
const customBgColor = (root) => {
    const {colorCode, isGradation} = root.dataset;

    root.querySelectorAll('.js-custom-bg-color__target').forEach((target) => {
        const isReadmoreBtn = target.classList.contains('c-button-readmore');

        if (isReadmoreBtn) {
            const rgb = getConvertHexToRgb(colorCode.replace(/^#/, '')).join(',');

            target.style.background = `linear-gradient(rgba(${rgb}, 0) -30%, rgb(${rgb}) 25%)`;

            return;
        }

        if (isGradation === 'true') {
            const json = JSON.parse(colorCode);

            target.style.background = `linear-gradient(${json.from}, ${json.to})`;

            return;
        }
        target.style.background = colorCode;
    });
};

export default () => {
    const roots = document.querySelectorAll('.js-custom-bg-color');

    if (!roots) {
        return;
    }
    roots.forEach((root) => {
        customBgColor(root);
    });
};
